import React, { FC, DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { resolveUrlForApp } from '../../utils/appUtils';

export const BigidMeImage: FC<DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>> = ({
  src,
  ...restProps
}) => {
  return <img src={resolveUrlForApp(src)} {...restProps} />;
};
